export default __webpack_public_path__ + "static/media/buttons-search-active.725bd73f.svg";